import { fetchPersea } from "@/config/axios/config-axios";


export const getActivities = async ({ wallet }: { wallet?: string }) => {
    if (!wallet) {
        console.warn('getActivities: No wallet provided');
        return [];
    }
    return await fetchPersea(`/history?wallet=${wallet}`, 'GET');
};

export const getBalance = async () => {
    return await fetchPersea(`/coin/balance`, 'GET');
};
